module.exports = __webpack_public_path__ + "img/product_105.351bc51.webp";